import { useMutation } from '@tanstack/react-query'
import { client } from './';

const getData = async (query: string) => {
  const queries = [
    {
      indexName: 'assets',
      query,
    },
    {
      indexName: 'hashtags',
      query,
    },
    {
      indexName: 'salons_profiles',
      query,
    },
    {
      indexName: 'posts',
      query,
    },
  ];

  try {
    const response = await client.multipleQueries(queries)
    const mappedResponse: any = []
    response.results.forEach((e: any) => {
      e.hits.forEach((children: any) => {
        const suggestion = children.name || children.label || children.transcript
        if (suggestion) {
          mappedResponse.push(suggestion)
        }
      })
    })

    return mappedResponse
  } catch (error) {
    return {}
  }
}

// export default function useGetQuerySuggestion(query: string) {
//   return useQuery({
//     queryKey: ['useGetQuerySuggestion'],
//     queryFn: () => getData(query),
//     staleTime: 0,
//     cacheTime: 0,
//   })
// }

export default function useGetQuerySuggestion() {
  return useMutation((query: string) => getData(query), {
    onSuccess: async (data) => data,
  })
}
